import { CheckmarkThickOutlined, CloseOutlined } from '@icon';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import Typography from '../typography';
import { passwordValidation } from './password-checks.schema';
import { IconColSC, MessageRowSC, PasswordChecksSC } from './password-checks.styled';

const rules = ['min8', 'one_uppercase', 'one_lowercase', 'one_number'];

interface PasswordChecksProps {
  password?: string;
  style?: React.CSSProperties;
  className?: string;
}

const PasswordChecks: React.FC<PasswordChecksProps> = ({ password, ...rest }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    passwordValidation
      .validate(password, { abortEarly: false })
      .then(() => setErrors([]))
      .catch((err: any) => setErrors(err.errors));
  }, [password]);

  return (
    <PasswordChecksSC {...rest}>
      {rules.map((id) => {
        const passed = errors.indexOf(id) === -1;

        return (
          <MessageRowSC key={id}>
            <IconColSC>
              {passed ? (
                <CheckmarkThickOutlined width={16} height={16} color={theme.color.solid.success} />
              ) : (
                <CloseOutlined width={16} height={16} color={theme.color.tint.secondary} />
              )}
            </IconColSC>
            <Typography
              display="captionLarge"
              variant="default"
              style={{ color: passed ? theme.color.tint.success : theme.color.tint.secondary }}
            >
              {formatMessage({ id: `validation.${id}` })}
            </Typography>
          </MessageRowSC>
        );
      })}
    </PasswordChecksSC>
  );
};

export default PasswordChecks;
